<template>
    <div id="app">
        <Header></Header>
        <router-view />
        <!-- <Footer v-if="this.$store.state.homeType != 1"></Footer> -->
        <Footer></Footer>
    </div>
</template>
<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
    name: "app",
    components: {
        Header,
        Footer,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
#app {
    font-family: "PingFang SC", Microsoft Yahei, Helvetica Neue, Helvetica,
        Arial, Lantinghei SC, Hiragino Sans GB, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height:100%;
}
.el-pagination.is-background .el-pager li {
    background-color: #f5f5f5 !important;
    color: #666 !important;
    border: 1px solid rgba(235, 235, 235, 1) !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    color: #5aaafa !important;
    background-color: #f5faff !important;
    border: 1px solid rgb(193, 210, 226) !important;
}
</style>
